import { Action } from '@ngrx/store';
import { PatientRecordsState } from './patient_records_store/patient-records.model';
import { patientRecordsReducer } from './patient_records_store/patient-records.reducer';
import { demographicsEditorRecordsState } from './demographics_editor_store/demographics-editor.model';
import { demographicsEditorRecordsReducer } from './demographics_editor_store/demographics-editor.reducer';
import { CreateSoapState } from './create_soap_notes_store/create-soap.model';
import { createSoapReducer } from './create_soap_notes_store/create-soap.reducer';
import { SoapChronologyState } from './soap_chronology_store/soap-chronology.model';
import { soapChronologyReducer } from './soap_chronology_store/soap-chronology.reducer';
import { IncomingSoapAlertState } from './incoming_soap_alert_store/incoming_soap_alert.model';
import { incomingSoapAlertReducer } from './incoming_soap_alert_store/incoming_soap_alert.reducer';

export interface AppState {
    patientRecordsReducer: PatientRecordsState;
    demographicsEditorRecordsReducer: demographicsEditorRecordsState;
    createSoapReducer: CreateSoapState;
    soapChronologyReducer: SoapChronologyState;
    incomingSoapAlertReducer: IncomingSoapAlertState;
};

export const reducers = { patientRecordsReducer, demographicsEditorRecordsReducer, createSoapReducer, soapChronologyReducer, incomingSoapAlertReducer };
